export default {
  // addClass: function(element, className) { //增加 classname
  //   if (!new RegExp("(^|\\s)" + className + "(\\s|$)").test(element.className)) element.className += ' ' + className;
  // },
  // removeClass: function(element, className) { //删除 classname
  //   element.className = element.className.replace(new RegExp("(^|\\s)" + className + "(?=(\\s|$))", "g"), '');
  // },

  regExpTelephonePhone(value) {
    //电话 + 手机 正则表达式
    let regExp = /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/;
    // console.log("regExpPhone", regExp.test(value));
    return regExp.test(value);
  },
  regExpEmail(value) {
    //邮箱正则表达式
    let regExp = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
    // console.log("regExpEmail", regExp.test(value));
    return regExp.test(value);
  },
  regExpPositiveInteger(value) {
    //正整数正则表达式
    let regExp = /^[1-9]\d*$/;
    // console.log("regExpPositiveInteger", regExp.test(value));
    return regExp.test(value);
  },
  aryListFindOne(list, listKey, findId) {
    // 从数组里面找到某一个
    // 数组  数组中的key 匹配属性
    let obj = {};
    list.map((item, index) => {
      if (item[listKey] == findId) {
        obj = item;
      }
    });
    return obj;
  },
  download(item) {
    let a = document.createElement("a");
    let event = new MouseEvent("click");
    a.download = mediaUrl + item.route; //文件名称
    a.href = mediaUrl + item.route;
    a.dispatchEvent(event);
  },
  pre_pdf(item) {
    window.location.href = `http://wkt.littlewindy.com/mobile/pdf_pre/web/viewer.html?pdf=${mediaUrl}${
      item.route
    }&v=${Math.random()}`;
  },
  get_week(value) {
    //周几
    return "周" + "日一二三四五六 ".charAt(new Date(value).getDay());
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/common.js